export default {
    drop: 'Drop',
    more: 'More',
    total: 'Total'
};
